// ABOUTME: Which checkout the shared payment form serves: a course purchase or a license purchase (DVLP-7860).
// ABOUTME: License purchase adds a billing address, a primary confirm button and a compact form that fits its fixed dialog.
import { StripeElementsOptions } from '@stripe/stripe-js';

export type CheckoutKind = 'course' | 'license';

export const confirmButtonColor = (checkout: CheckoutKind): 'gray' | 'primary' => {
  switch (checkout) {
    case 'course': {
      return 'gray';
    }
    case 'license': {
      return 'primary';
    }
  }
};

export const formPaddingClassName = (checkout: CheckoutKind): string => {
  switch (checkout) {
    case 'course': {
      return 'p-6 pt-10 md:py-12 md:pl-8 md:pr-12';
    }
    case 'license': {
      return 'min-h-0 flex-1 px-6 pb-6 pt-4 md:px-8';
    }
  }
};

/**
 * Card plus a full billing address is about eight rows of fields. At the course
 * checkout's spacing that runs well past the license dialog, which keeps one size
 * across steps, so the license form tightens row gaps, labels and input padding.
 */
const compact = (options: StripeElementsOptions): StripeElementsOptions => {
  const appearance = options.appearance ?? {};
  const rules = appearance.rules ?? {};
  return {
    ...options,
    appearance: {
      ...appearance,
      variables: { ...appearance.variables, spacingGridRow: '10px', spacingUnit: '3px' },
      rules: {
        ...rules,
        '.Label': { ...rules['.Label'], fontSize: '13px', marginBottom: '4px' },
        '.Input': { ...rules['.Input'], padding: '6px 12px', lineHeight: '20px' },
      },
    },
  };
};

export const elementsOptionsFor =
  (checkout: CheckoutKind) =>
  (options: StripeElementsOptions): StripeElementsOptions => {
    switch (checkout) {
      case 'course': {
        return options;
      }
      case 'license': {
        return compact(options);
      }
    }
  };
